import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import PortalVue from 'portal-vue';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap';
import './assets/styles/main.scss';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';


const app = createApp(App);

// Inicializa e usa o Pinia primeiro
const pinia = createPinia();
app.use(pinia);
app.component('VueDatePicker', VueDatePicker);

// Agora sim: só depois de usar o Pinia, pode acessar a store
import { useAuthStore } from '@/stores/auth';
const auth = useAuthStore();
auth.loadFromStorage();

// Outros plugins e mount
app.use(router).use(PortalVue).mount('#app');
